import React from 'react';

const AccordionItem = ({ titleKey, isOpen, onToggle, t, children }) => (
  <div className="t-border-b t-border-g200">
    <button
      type="button"
      onClick={onToggle}
      className="t-flex t-w-full t-cursor-pointer t-items-center t-justify-between t-gap-3 t-border-0 t-bg-transparent t-py-5 t-text-left t-outline-none t-transition-colors hover:t-text-navy"
    >
      <span className="t-font-normal t-text-[18px] t-text-gray-900" style={{ fontFamily: 'DM Serif Display, serif' }}>
        {t(titleKey)}
      </span>
      <span
        className={`t-flex-none t-text-lg t-text-g500 t-transition-transform t-duration-300 ${
          isOpen ? 't-rotate-180' : ''
        }`}
      >
        ⌄
      </span>
    </button>
    <div
      className={`t-overflow-hidden t-transition-all t-duration-300 ${
        isOpen ? 't-max-h-[800px] t-pb-5' : 't-max-h-0'
      }`}
    >
      {children}
    </div>
  </div>
);

const Omega3ProductAccordions = ({ t }) => {
  const [openAccordion, setOpenAccordion] = React.useState(null);

  return (
    <div className="t-mt-5 t-border-t t-border-g200">
      <AccordionItem
        titleKey="Omega3_Accordion_Nutrition_Title"
        isOpen={openAccordion === 'nutrition'}
        onToggle={() => setOpenAccordion(openAccordion === 'nutrition' ? null : 'nutrition')}
        t={t}
      >
        <table className="t-w-full t-border-collapse t-text-[13px]">
          <thead>
            <tr>
              <th className="t-border-b-2 t-border-navy t-pb-2 t-text-left t-text-[12px] t-font-semibold t-uppercase t-tracking-[0.04em] t-text-navy">
                {t('Omega3_Accordion_Nutrition_Th_Dose')}
              </th>
              <th className="t-border-b-2 t-border-navy t-pb-2 t-text-right t-text-[12px] t-font-semibold t-uppercase t-tracking-[0.04em] t-text-navy">
                {t('Omega3_Accordion_Nutrition_Th_Amount')}
              </th>
            </tr>
          </thead>
          <tbody>
            {[
              { key: 'Omega3_Accordion_Nutrition_FishOil', amount: '1000 mg', sub: false },
              { key: 'Omega3_Accordion_Nutrition_EPA', amount: '400 mg', sub: true },
              { key: 'Omega3_Accordion_Nutrition_DHA', amount: '300 mg', sub: true },
              { key: 'Omega3_Accordion_Nutrition_Other', amount: '~100 mg', sub: true },
            ].map((row) => (
              <tr key={row.key}>
                <td
                  className={`t-border-b t-border-g200 t-py-2 ${
                    row.sub ? 't-pl-4 t-italic t-text-g500' : 't-text-gray-900'
                  }`}
                >
                  {t(row.key)}
                </td>
                <td className="t-border-b t-border-g200 t-py-2 t-text-right t-text-gray-900">
                  {row.amount}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </AccordionItem>

      <AccordionItem
        titleKey="Omega3_Accordion_Ingredients_Title"
        isOpen={openAccordion === 'ingredients'}
        onToggle={() => setOpenAccordion(openAccordion === 'ingredients' ? null : 'ingredients')}
        t={t}
      >
        <p className="!t-m-0 t-text-[14px] t-leading-[1.65] t-text-g500">
          {t('Omega3_Accordion_Ingredients_Text')}
        </p>
      </AccordionItem>

      <AccordionItem
        titleKey="Omega3_Accordion_Details_Title"
        isOpen={openAccordion === 'details'}
        onToggle={() => setOpenAccordion(openAccordion === 'details' ? null : 'details')}
        t={t}
      >
        <div className="t-flex t-flex-col t-gap-5">
          {[
            {
              label: 'Omega3_Accordion_Details_Directions_Label',
              text: 'Omega3_Accordion_Details_Directions_Text',
            },
            {
              label: 'Omega3_Accordion_Details_Storage_Label',
              text: 'Omega3_Accordion_Details_Storage_Text',
            },
            {
              label: 'Omega3_Accordion_Details_Caution_Label',
              text: 'Omega3_Accordion_Details_Caution_Text',
            },
          ].map((block) => (
            <div key={block.label}>
              <p className="!t-m-0 !t-mb-1 t-text-[14px] t-font-bold t-text-gray-900">
                {t(block.label)}
              </p>
              <p className="!t-m-0 t-text-[14px] t-leading-[1.65] t-text-g500">
                {t(block.text)}
              </p>
            </div>
          ))}
        </div>
      </AccordionItem>
    </div>
  );
};

export default Omega3ProductAccordions;
